/* eslint-disable no-console */
import {Divider, Flex, Progress} from 'antd';
import React from 'react';

import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import BoxContent from '../../../../components/BoxContent/BoxContent';
import PilComp from '../../../../components/DisplayComponent/PilComp';
import sumTableValue from '../../../../components/Table/Utils/sumTableValue';
import {
  blockAccessTypes,
  blockModelMessages,
  blockModelTypes
} from '../../../../constants/blockPageConstatnts';
import {formatIndian} from '../../../../utils/formatIndian';
import {roundToDecimal} from '../../../netZero/constants/commonFunctions';

import {DataScope} from './CommonData';
import {SCOPE_COLORS} from './constants/commonConstants';

const Scope: React.FC<{
  scopeData: DataScope[];
  scopeNumber: number;
  isBlock: boolean;
  totalEmissions?: number;
}> = ({scopeData = [], scopeNumber, isBlock, totalEmissions}) => {
  const scopeTotal = roundToDecimal(
    sumTableValue(scopeData, 'value', false) as number
  );
  const percentage =
    totalEmissions != null && totalEmissions > 0
      ? roundToDecimal((scopeTotal / totalEmissions) * 100)
      : scopeTotal > 0
        ? 100
        : 0;

  return (
    <BoxContent noBackground={true}>
      <Flex
        className="scopeBoxContent"
        style={{
          flexDirection: 'column',
          height: '31.5rem'
        }}
      >
        <div className="scopeEmissionSummary">
          <Flex
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Flex
              style={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                flex: 1
              }}
            >
              <div className="sumEmission">
                <span className="sumEmissionValue">
                  {formatIndian(scopeTotal)}
                </span>
                <span className="sumEmissionUnit">tCO2e</span>
              </div>
              <div className="totalCarbonEmission">
                Scope {scopeNumber} Emissions
              </div>
            </Flex>
            {isBlock ? null : (
              <Flex
                className="rightFlex"
                style={{
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  flex: 1
                }}
              >
                <Progress
                  className="scopeDonutProgress"
                  style={{aspectRatio: '1', width: '75px'}}
                  type="circle"
                  percent={percentage}
                  format={() => `${percentage}%`}
                  showInfo={true}
                  trailColor="#D1DBE6"
                  strokeColor={SCOPE_COLORS[scopeNumber]?.progress ?? '#0E4B72'}
                  strokeWidth={10}
                  strokeLinecap="square"
                />
              </Flex>
            )}
          </Flex>
        </div>
        <Divider className="scopeDivider" />
        {isBlock ? (
          <BlockAccessPage
            messageTitle={blockModelMessages.scope.title.unlockMessage(
              scopeNumber?.toString()
            )}
            messageDescription={blockModelMessages.scope.description.message(
              scopeNumber?.toString()
            )}
            blockedType={blockAccessTypes.PARTIAL}
            modelType={blockModelTypes.SCOPE_NORMAL}
          />
        ) : null}
        {isBlock ? null : (
          <>
            <Flex className="emissionByTitle" justify="space-between">
              <div>Emission by</div>
              <div>tCO2e</div>
            </Flex>
            <div className="scopeEmissionList">
              {scopeData?.map((item: any, index) => (
                <Flex key={index} className="listEmission">
                  <div className="listEmissionLabel">{item?.label}</div>
                  <PilComp
                    value={formatIndian(item?.value)}
                    color={SCOPE_COLORS[scopeNumber]?.pill ?? item?.background}
                    style={{color: '#000000'}}
                  />
                </Flex>
              ))}
            </div>
          </>
        )}
      </Flex>
    </BoxContent>
  );
};

export default Scope;
